import { getApiErrorMessage, getErrorCode } from "shared/utils";
import type { ApiError } from "shared/utils";

// Тексты по машинному коду { "code" } — приоритетнее message бэка.
const CODE_MESSAGES: Record<string, string> = {
  wheel_create_forbidden: "You don't have permission to create promos.",
  insufficient_balance: "Not enough real balance for the prize pool.",
  wheel_raffle_forbidden: "This promo belongs to another user.",
  wheel_raffle_not_found: "Promo not found.",
  wheel_raffle_not_drawn: "Winners will be available after the draw.",
  wheel_draw_forbidden: "You can only draw your own promos.",
  already_drawn: "This promo has already been drawn.",
  // Swagger и handoff называют код по-разному — поддерживаем оба.
  not_started: "The promo hasn't started yet.",
  wheel_draw_not_started: "The promo hasn't started yet.",
  invalid_status: "This promo can't be drawn in its current status.",
  // v2: создание, поиск, вступление.
  invalid_symbols: "Some of the selected pairs are unavailable.",
  invite_code_not_allowed: "Invite code is only allowed for private promos.",
  duration_out_of_range: "Duration must be between 1 minute and 24 hours.",
  tier_unconfigured: "Statuses are not configured yet. Try again later.",
  raffle_not_found: "Promo not found.",
  raffle_not_private: "This promo is open — no code needed.",
  raffle_closed: "This promo is no longer accepting participants.",
  invalid_code: "Invalid invite code.",
  tier_too_low: "Your status is too low for this promo.",
  already_joined: "You've already joined this promo.",
  search_rate_limited: "Too many searches. Please wait a minute.",
  join_rate_limited: "Too many attempts. Please wait a minute.",
};

// validation_error сюда не входит: message бэка точнее общего текста.
const STATUS_MESSAGES: Record<number, string> = {
  400: "Please check the entered data.",
  401: "Session expired. Please log in again.",
  503: "Service is temporarily unavailable. Please try again later.",
};

const DEFAULT_MESSAGE = "Something went wrong. Please try again.";

export const getWheelRaffleErrorMessage = (error: ApiError): string | null => {
  const code = getErrorCode(error);
  const codeMessage = code ? CODE_MESSAGES[code] : undefined;
  return (
    codeMessage ?? getApiErrorMessage(error, STATUS_MESSAGES, DEFAULT_MESSAGE)
  );
};
